// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__gvPXx","footer":"ModalCreateQualiphyProcedure_footer__Ajf5X","additionData":"ModalCreateQualiphyProcedure_additionData__2MWL2"};